<template>
  <component
    :is="props.tag"
    class="collapse-wrapper"
  >
    <template v-for="(item, index) in props.collapseGroup" :key="item?.uid || index">
      <slot :item="item" :index="index"></slot>
    </template>
  </component>
</template>

<script setup lang="ts" generic="T">
import { VNode } from 'vue';


defineSlots<{
  default?(props : { item: T, index: number }): VNode
}>()

const props = withDefaults(defineProps<{
  tag?: string,
  collapseGroup: T[],
}>(), {
  tag: 'div',
})
</script>

<style scoped lang='scss'>
.collapse-wrapper {
  counter-reset: section;
  margin-block: 1rem;
}
</style>
